import React, { useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';

const EditDeveloperModal = ({ isOpen, setIsOpen, fetchData, editId, formData, setFormData, imagePreview }) => {
  const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
  const [image1, setImage1] = useState(null);
  const [imageError, setImageError] = useState("");
  const [previewURL, setPreviewURL] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleStatusChange = (selectedOption) => {
    setFormData(prev => ({ ...prev, status: selectedOption ? selectedOption.value : "" }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const allowedExtensions = ['jpeg', 'jpg', 'png', 'webp', 'avif'];
      const extension = file.name.split('.').pop().toLowerCase();

      if (!allowedExtensions.includes(extension)) {
        setImageError("Only jpeg, jpg, png, webp, avif formats are allowed.");
        setImage1(null);
        setPreviewURL(null);
        return;
      }

      if (file.size > 1024 * 1024) {
        setImageError("Image size must be less than 1MB");
        setImage1(null);
        setPreviewURL(null);
        return;
      }

      setImageError("");
      setImage1(file);
      setPreviewURL(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (imageError) {
      toast.error("Please fix the image error", { position: "top-center", autoClose: 2000 });
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append('category', formData.category);
    formDataToSend.append('position', formData.position);
    formDataToSend.append('status', formData.status);
    formDataToSend.append('user_id', isLoggedIn.user_id);

    if (image1) {
      formDataToSend.append('image_logo', image1);
    }

    try {
      const response = await fetch(`https://100real.xyz/categoryfeaturedev/updatecategory/${editId}`, {
        method: 'PUT',
        body: formDataToSend,
      });

      if (response.status === 200) {
        fetchData();
        toast.success('Category updated successfully!', { position: 'top-center', autoClose: 2000 });
        setIsOpen(false);
        setFormData({ category: '', status: '', position: '' });
        setPreviewURL(null);
        setImage1(null);
      } else if (response.status === 400) {
        toast.error('Failed to update category', { position: 'top-center', autoClose: 2000 });
      }
    } catch (error) {
      toast.error('Error occurred while updating category', { position: 'top-center', autoClose: 2000 });
    }
  };

  const statusOptions = [
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
  ];

  if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
      <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 className="oms-modal-title">Edit Developer</h2>
        <form className="oms-modal-form" onSubmit={handleSubmit}>
          {/* Image Upload */}
          <div className="oms-form-group">
            <label htmlFor="image" className="oms-form-label">Image</label>
            <input
              type="file"
              name="image"
              id="image"
              accept="image/*"
              onChange={handleImageChange}
            />
            {imageError && <p style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{imageError}</p>}
            {previewURL ? (
              <img src={previewURL} alt="New Upload Preview" style={{ width: "100px", marginTop: "10px" }} />
            ) : imagePreview ? (
              <img src={`https://100real.xyz/${imagePreview}`} alt="Current" style={{ width: "100px", marginTop: "10px" }} />
            ) : null}
          </div>

          {/* Category Input */}
          <div className="oms-form-group">
            <label htmlFor="category" className="oms-form-label">Developer Name</label>
            <input
              type="text"
              name="category"
              id="category"
              value={formData.category}
              placeholder="Enter Category"
              onChange={handleChange}
              required
            />
          </div>

          {/* Status Selector */}
          <div className="oms-form-group">
            <label htmlFor="status" className="oms-form-label">Status</label>
            <Select
              options={statusOptions}
              placeholder="Select status"
              value={statusOptions.find(option => option.value === formData.status)}
              onChange={handleStatusChange}
              required
            />
          </div>

          {/* Position Input */}
          <div className="oms-form-group">
            <label htmlFor="position" className="oms-form-label">Position</label>
            <input
              type="text"
              id="position"
              name="position"
              placeholder="Enter Position"
              value={formData.position}
              onChange={handleChange}
              required
            />
          </div>

          {/* Actions */}
          <div className="oms-form-actions">
            <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
            <button type="submit">Submit</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditDeveloperModal;
